import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag
  },
  data: function data() {
    return {
      dataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        cmsType: 5,
        pageSize: 999,
        cmsStatus: 1,
        orderBy: 'time',
        eventId: ''
      }
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (this.$route.query.type) {
      this.queryParam.cmsType = this.$route.query.type;
    }
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    eventChange: function eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCms/getCmsList", this.queryParam).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.dataSource = res.result.records;
        }
        _this.loading = false;
      });
    },
    toDetail: function toDetail(item) {
      this.currentItem = item;
      this.videoVisible = true;
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id).then(function (res) {});
    }
  }
};